/**
 * Remove market prefix from the given path
 */
export const removeMarketFromPath = (path: string, marketPrefix = '') => {
  if (!marketPrefix) return path;
  return path.replace(new RegExp(`[/]${marketPrefix}(?:[/]|$)`), '/');
};
